module.exports = __webpack_public_path__ + "img/back-arrow.360fca42.svg";